import { checkDateToFormat, checkDateTimeToFormat } from "@/utils/format";
import moment from "moment";
import { Utils } from "@core/utils/utilsCustom";
import { GetBookingDetail, UpdateStatusBooking } from "@/api";

export default {
  data() {
    return {
      booking_note: null,
      isUpdate: false,
    };
  },
  methods: {
    // function check status return class color
    checkStatusColor(status) {
      if (Utils.BOOKING_TAB.IN_PROCESS.split(",").includes(status.toString())) {
        return "bg-in-progress";
      } else if (
        Utils.BOOKING_TAB.BOOKING_APPROVAL.split(",").includes(
          status.toString()
        )
      ) {
        return "bg-booking-approval";
      } else if (
        Utils.BOOKING_TAB.IN_TRANSIT.split(",").includes(status.toString())
      ) {
        return "bg-in-transit";
      } else if (
        Utils.BOOKING_TAB.DELIVERED.split(",").includes(status.toString())
      ) {
        return "bg-delivered";
      } else if (
        Utils.BOOKING_TAB.PAYMENT.split(",").includes(status.toString())
      ) {
        return "bg-payment";
      } else if (
        Utils.BOOKING_TAB.CANCELLED.split(",").includes(status.toString())
      ) {
        return "bg-cancelled";
      }
    },

    rowStyleClassFn(row) {
      setTimeout(() => {
        document.getElementsByClassName("bg-status").forEach(function (v) {
          if (v.innerText.includes("New Booking")) {
            v.classList.add("bg-new-booking");
          } else if (v.innerText.includes("In progress")) {
            v.classList.add("bg-in-progress");
          } else if (v.innerText.includes("Booking sent")) {
            v.classList.add("bg-booking-acknowledge");
          } else if (v.innerText.includes("New shipment")) {
            v.classList.add("bg-new-shipment");
          } else if (
            ["Be transported", "Being transported"].includes(v.innerText)
          ) {
            v.classList.add("bg-be-transported");
          } else if (v.innerText.includes("Completed")) {
            v.classList.add("bg-completed");
          } else if (v.innerText.includes("Canceled")) {
            v.classList.add("bg-canceled");
          } else if (v.innerText.includes("Un Paid")) {
            v.classList.add("bg-unpaid");
          } else if (v.innerText.includes("Paid")) {
            v.classList.add("bg-paid");
          }
        });
      }, 100);
      return "VGT-row";
    },
    onHandlerViewTab(row, tab) {
      this.activeTab = tab;
      this.onRowDoubleClick({ row });
    },
    async onRowDoubleClick({ row }) {
      // console.log('row', row)
      localStorage.setItem("idBooking", JSON.stringify(row.id));
      this.$loading.show();

      this.$store.commit("masterData/SET_TRUCK_LIST", []);

      // console.group("mixis");
      // console.groupEnd();
      try {
        if (
          row?.status_id?.toString() ===
            this.$Utils.BOOKING_NAME.BOOKING_SUBMITTED.toString() &&
          (this.userData.userType ==
            this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
            this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin)
        ) {
          UpdateStatusBooking(row.id);
          row.status_id = this.$Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST;
        }

        const rs = await GetBookingDetail({
          id: row.id,
        });
        this.status = null;
        this.quotation = null;
        this.request_quotation = null;
        this.booking = null;
        this.costs_info = null;
        this.proc_code = null;
        this.shipment = null;
        if (rs?.proc_code) {
          this.proc_code = rs?.proc_code
            .split(",")
            .filter((item) => item.trim() !== "");
        }
        if (rs?.shipment_detail != null) {
          this.shipment_detail = JSON.parse(rs?.shipment_detail);
        } else {
          this.shipment_detail = null;
        }
        // if(rs?.shipment_info_all){
        //   this.shipment = JSON.parse(rs?.shipment_info_all);
        // }
        if (rs?.status) {
          this.status = rs?.status;
        }
        if (rs?.booking_note && typeof rs?.booking_note != "undefined") {
          this.isUpdate = true;

          // console.log("object");
          this.booking_note = JSON.parse(rs?.booking_note);
          this.booking_note.status_id = rs?.status_id;
          if (this.booking_note) {
            this.booking_note.note = JSON.parse(rs?.booking_note).note;
            (this.booking_note.pol_name = row?.pol_name || row.pol),
              (this.booking_note.pod_name = row.pod_name || row.pod),
              (this.booking = {});
          }
        } else {
          this.booking_note = null;
        }

        this.shipment_on_fast = JSON.parse(rs?.shipment_on_fast_info);

        if (rs?.shipment_on_tms_info != null) {
          this.shipment_on_tms = JSON.parse(rs?.shipment_on_tms_info);
        } else {
          this.shipment_on_tms = null;
        }

        this.request_quotation = JSON.parse(rs?.request_quotation_info);
        if (this.shipment && this.request_quotation) {
          this.shipment.forEach((k) => {
            if (k.id == "4.1") {
              this.request_quotation.HBL = k.hbl;
            }
          });
        }
        this.request_quotation.id = row.id;
        this.request_quotation.status_id = row.status_id;
        this.request_quotation.customer_id = rs?.customer_id;
        this.request_quotation.sale_id = rs?.sale_id;
        this.request_quotation.sale_name = rs?.sale_name;
        this.request_quotation.sale_phone = rs?.sale_phone;
        this.request_quotation.sale_email = rs?.sale_email;
        this.request_quotation.cancel_reason = rs?.cancel_reason;
        this.request_quotation.canceled_date = rs?.canceled_date;
        this.request_quotation.HBL = row.booking_no;
        // this.request_quotation.canceled_date =  "22/12/2022";
        this.request_quotation.accept_edit = rs?.accept_edit;
        this.request_quotation.completed_date = rs?.completed_date;

        this.request_quotation.company_id = rs?.company_id;
        this.request_quotation.locked = rs?.locked;

        this.request_quotation.customer_name = rs?.customer_name;
        this.request_quotation.customer_phone = rs?.customer_phone;
        this.request_quotation.customer_email = rs?.customer_email;
        this.request_quotation.commodity = rs?.commodity;
        this.request_quotation.customer_company_address =
          rs?.customer_company_address;
        this.request_quotation.pod = row.pod;
        this.request_quotation.pol = row.pol;

        this.request_quotation.etd = checkDateToFormat(row.etd);
        this.request_quotation.eta = checkDateToFormat(row.eta);
        this.request_quotation.cargo_ready = checkDateTimeToFormat(
          this.request_quotation.cargo_ready
        );
        this.request_quotation.pick_up_date = checkDateTimeToFormat(
          row.pick_up_date
        );

        this.request_quotation.delivery_date = checkDateTimeToFormat(
          row.delivery_date
        );

        this.request_quotation.shipment_on_fast = JSON.parse(
          rs?.shipment_on_fast_info
        );

        this.request_quotation.shipment_on_tms = JSON.parse(
          rs?.shipment_on_tms_info
        );
        if (!!rs?.booking_on_fast_info) {
          this.request_quotation.booking_on_fast_info = JSON.parse(
            rs?.booking_on_fast_info
          );
        }

        this.request_quotation.customer_company_name =
          row.customer_company_name;
        if (rs?.files != null && rs?.file != "") {
          this.request_quotation.files = [];
          if (typeof this.request_quotation.files != "array") {
            this.request_quotation.files = [];
          }

          JSON.parse(rs?.files).length > 0
            ? this.request_quotation.files.push(...JSON.parse(rs?.files))
            : "";
        } else {
          this.request_quotation.files = eval(this.request_quotation.files);
        }

        this.request_quotation.accept_files =
          JSON.parse(rs?.accept_files) || [];

        rs?.shipment_on_fast_info != null || rs?.shipment_on_tms_info != null
          ? await this.loadTrackTrace()
          : "";
        if (rs?.quotation_info != null && rs?.quotation_info != "") {
          this.quotation = JSON.parse(rs?.quotation_info);
          this.quotation.id = row.id;
          this.quotation.status_id = row.status_id;
          // this.request_quotation.Carriers = this.quotation?.shipping_line || this.quotation?.Carriers;

          // this.request_quotation.cut_off = this.quotation.cut_off;

          this.request_quotation.valid_from = this.quotation.valid_from;
          this.request_quotation.valid_to = this.quotation.valid_to;
          this.request_quotation.fred = this.quotation.fred;
          this.request_quotation.transit_time = this.quotation.transit_time;
          this.request_quotation.via = this.quotation.via;

          // this.request_quotation.so_khoi = this.quotation.so_khoi;
        } else {
          this.request_quotation.quotation_info = null;
        }
        if (rs?.booking_info != null && rs?.booking_info != "") {
          this.booking = JSON.parse(rs?.booking_info);
          this.booking.id = row.id;
          this.booking.status_id = row.status_id;
          // this.request_quotation.Carriers = this.booking?.shipping_line || this.request_quotation.Carriers;

          //  console.log(
          //   this.request_quotation
          //  )
          // this.request_quotation.cut_off_time = this.booking.cut_off;
          this.request_quotation.booking_notes = this.booking.notes;
          this.request_quotation.fred = this.booking.fred;
        }
        if (rs?.costs_info != null && rs?.costs_info != "") {
          this.costs_info = JSON.parse(rs?.costs_info);
          this.costs_info.id = row.id;
          this.costs_info.status_id = row.status_id;
        }

        this.$nextTick(() => {
          this.activeTab = 0;

          if (
            this.request_quotation.status_id.toString() ===
              this.$Utils.BOOKING_NAME.CONFIRMED_QUOTATION.toString() &&
            !this.booking_note
          ) {
            this.isUpdate = false;
            this.activeTab = 8;
            this.booking_note = {
              shipping_line: this.request_quotation.shipping_line,
              company_id: rs?.company_id,
              company_name: row.customer_company_name,
              customer_name: rs?.customer_name,
              sale_name: rs?.sale_name,
              vessel_name: this.request_quotation.vessel_name,
              pol_name:
                this.request_quotation.pol_name || this.request_quotation.pol,
              pod_name:
                this.request_quotation.pod_name || this.request_quotation.pod,
              placeOfDelivery_name: null,
              goods_type_name: this.request_quotation.goods_type_name,
              service_type: "3",
              vessel: this.request_quotation.vessel,
              customer_id: rs?.customer_id,
              customer_email: rs?.customer_email,
              sale_id: rs?.sale_id,
              booking_date: moment().format("DD/MM/YY HH:mm"),
              booking_no: row.id,
              place_of_stuffing: this.request_quotation.place_of_stuffing,
              contact: "Mr HAI : 0938.108.990",
              closing_time: this.request_quotation.closing_time,
              cut_si_vgm: this.request_quotation.cut_si_vgm,
              pol_port: this.request_quotation.pol_port,
              pod_port: this.request_quotation.pod_port,
              placeOfDelivery: null,
              eta: row.eta,
              etd: row.etd,
              goods_type: this.request_quotation.goods_type,
              packageNumber: this.request_quotation.packageNumber,
              trong_luong: this.request_quotation.trong_luong,
              so_khoi: this.request_quotation.so_khoi,
              note: `1. Please contact our operation 2 hours before loading cargo to stuffing place.
        2. Please bring a booking note, declaration, barcode, vgm.
        3. Wooden packages & wooden products must be fumigated at shipper's premise.
        4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.
        5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.
        6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking. 
        7. For European trade lane: HS code of cargo required to provide at least two days before ETD.
        8. For US/Canada trade lanes: No personal effects are accepted.
        9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.
        In case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.`,
            };
          }

          if (
            (row.status_id.toString() ===
              this.$Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST.toString() &&
              this.userData.userType ==
                this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale) ||
            (row.status_id.toString() ===
              this.$Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST.toString() &&
              this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin)
          ) {
            this.showViewAll(
              "modal-confirm-booking",
              row,
              this.activeTab,
              true,
              rs || null
            );
            this.$loading.hide();
          } else {

            // kiem tra xem VAN co dimension  chưa có thì thêm vào tránh lỗi giao diện
            if (this.request_quotation?.service_type.toString() === "6") {
              this.request_quotation?.valueVan?.forEach((element) => {
                element?.VanLine?.forEach((item) => {
                  if (!item.dimension) {
                    item.dimension = {
                      length: null,
                      width: null,
                      height: null,
                    };
                  }
                });
              });
            }

            setTimeout(() => {
              this.$bvModal.show("modal-view-all");
              this.$loading.hide();
            }, 500);
          }
        });
      } catch (error) {
        console.log(error);
      }
      return;
    },
  },
};
